import React from 'react';
import {
  maxValue,
  minValue,
  number,
  ReferenceInput,
  required,
} from 'react-admin';
import ReferenceChild from '../../components/ReferenceChild';
import { perPage } from '../../helper';

const validatePriceSheet = [required(), number(), minValue(1), maxValue(20)];

const PriceSheetInput = ({ isRequired, alwaysOn = false, ...props }) => (
  <ReferenceInput
    validate={isRequired ? validatePriceSheet : []}
    source="price_sheet_id"
    reference="price-sheet"
    sort={{ field: 'price_sheet_id', order: 'ASC' }}
    perPage={perPage}
    alwaysOn={alwaysOn}
  >
    <ReferenceChild
      {...props}
      optionText="price_sheet_name"
      source="price_sheet_id"
    />
  </ReferenceInput>
);

export default PriceSheetInput;
